"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomHistory = exports.CreateEvent = void 0;
var generateKey = function () {
    return Math.random()
        .toString(36)
        .substr(2, 6);
};
// IE Polyfill for CustomEvent
var CreateEvent = function (windowInternal, documentInternal) { return function (event, params) {
    if (typeof windowInternal.CustomEvent === 'function') {
        return new windowInternal.CustomEvent(event, params);
    }
    var paramsToFunction = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = documentInternal.createEvent('CustomEvent');
    evt.initCustomEvent(event, paramsToFunction.bubbles, paramsToFunction.cancelable, paramsToFunction.detail);
    evt.prototype = windowInternal.Event.prototype;
    return evt;
}; };
exports.CreateEvent = CreateEvent;
var getHistory = function (windowInternal, CreateEventInternal, generateKeyInternal) {
    return {
        replaceState: function (url, stateHistory) {
            var key = generateKeyInternal();
            var state = stateHistory || windowInternal.history.state;
            windowInternal.history.replaceState({ key: key, state: state }, null, url);
            windowInternal.dispatchEvent(CreateEventInternal('popstate'));
        },
    };
};
var getCustomHistory = function () { return getHistory(window, (0, exports.CreateEvent)(window, document), generateKey); };
exports.getCustomHistory = getCustomHistory;
//# sourceMappingURL=withRouter.js.map